/* Bull Kicks Rescued — size-match behavior (v5).
   Root fix: Rise theme emits <input name="Size-1\n"> — non-standard naming.
   Replaced name-attribute selectors with DOM-scope (closest-ancestor)
   containment. Adds variant-selects to the radio selectors (v4 only had
   variant-radios). Keeps v4 defensive fallbacks (variant:change event +
   MutationObserver + DOMContentLoaded init).
*/
(function () {
  "use strict";

  function normalizeSize(s) {
    if (s == null) return "";
    return String(s)
      .split("/")[0]
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/\.0+$/, "");
  }

  function getCurrentSize() {
    // Priority 1: any checked radio inside either custom element
    var checkedRadio = document.querySelector(
      'variant-selects input[type="radio"]:checked, variant-radios input[type="radio"]:checked',
    );
    if (checkedRadio && checkedRadio.value) return checkedRadio.value;

    // Priority 2: legacy fieldset fallback
    var fieldsetRadio = document.querySelector(
      'fieldset.product-form__input input[type="radio"]:checked',
    );
    if (fieldsetRadio && fieldsetRadio.value) return fieldsetRadio.value;

    // Priority 3: dropdown select inside either custom element
    var sel = document.querySelector(
      "variant-selects select, variant-radios select",
    );
    if (sel && sel.value) return sel.value;

    return null;
  }

  function init() {
    var section = document.querySelector("[data-bk-rescued]");
    if (!section) return;

    var rows = Array.from(section.querySelectorAll(".bk-rescued-row"));
    var countEl = section.querySelector("[data-bk-count]");
    var totalCount = rows.length;

    // ── BK_RESCUED_PICKER_v2 — size pill filter (default shows your size only) ──
    var pillsWrap = section.querySelector("[data-bk-size-pills]");

    function applySizeFilter(sz) {
      var normF = sz ? normalizeSize(sz) : null;
      rows.forEach(function (row) {
        var show = !normF || normalizeSize(row.dataset.bkSize) === normF;
        row.classList.toggle("bk-hide", !show);
      });
      if (pillsWrap) {
        Array.prototype.forEach.call(pillsWrap.querySelectorAll(".bk-rsz"), function (b) {
          b.classList.toggle("is-active", (b.dataset.sz || "") === (sz || ""));
        });
      }
    }

    function buildPills() {
      if (!pillsWrap) return;
      var counts = {}, order = [];
      rows.forEach(function (r) {
        var s = (r.dataset.bkSize || "").trim();
        if (counts[s] == null) { counts[s] = 0; order.push(s); }
        counts[s]++;
      });
      order.sort(function (a, b) { return (parseFloat(a) || 0) - (parseFloat(b) || 0); });
      var html = '<button type="button" class="bk-rsz" data-sz="">全部 (' + totalCount + ')</button>';
      order.forEach(function (s) {
        html += '<button type="button" class="bk-rsz" data-sz="' + s + '">' + s + ' (' + counts[s] + ')</button>';
      });
      pillsWrap.innerHTML = html;
      Array.prototype.forEach.call(pillsWrap.querySelectorAll(".bk-rsz"), function (b) {
        b.addEventListener("click", function () { applySizeFilter(b.dataset.sz || null); });
      });
    }

    function sizeHasUnits(sz) {
      var n = normalizeSize(sz);
      return !!n && rows.some(function (r) { return normalizeSize(r.dataset.bkSize) === n; });
    }
    // ── end picker v2 ──

    function updateState(selectedSize) {
      var norm = normalizeSize(selectedSize);
      var matchCount = 0;

      rows.forEach(function (row) {
        var rowSize = normalizeSize(row.dataset.bkSize);
        row.classList.remove("is-your-size", "is-other-size");
        if (!norm) return;
        if (rowSize === norm) {
          row.classList.add("is-your-size");
          matchCount++;
        } else {
          row.classList.add("is-other-size");
        }
      });

      section.classList.remove("is-size-matched", "is-size-no-match");
      if (!norm) {
        if (countEl) countEl.textContent = totalCount + " PAIR" + (totalCount > 1 ? "S" : "") + " AVAILABLE";
      } else if (matchCount > 0) {
        section.classList.add("is-size-matched");
        if (countEl) {
          var otherCount = totalCount - matchCount;
          countEl.textContent = otherCount > 0
            ? matchCount + " 適合你尺碼 · " + otherCount + " 其他"
            : matchCount + " 適合你尺碼";
        }
      } else {
        section.classList.add("is-size-no-match");
        if (countEl) countEl.textContent = "此 size 未有 · 共 " + totalCount + " 對其他 size";
      }
    }

    function onChange() {
      var sz = getCurrentSize();
      updateState(sz);
      applySizeFilter(sizeHasUnits(sz) ? sz : null);
    }

    // Primary: delegate on document, match by ancestor scope (no name-attr gating).
    document.addEventListener("change", function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (
        t.closest("variant-selects") ||
        t.closest("variant-radios") ||
        t.closest("fieldset.product-form__input")
      ) {
        onChange();
      }
    });

    // Secondary: Rise/Dawn sometimes emit a 'variant:change' custom event.
    document.addEventListener("variant:change", onChange);

    // Tertiary: MutationObserver on the picker(s) — catches attribute flips
    // that don't bubble a change event.
    var pickers = document.querySelectorAll("variant-selects, variant-radios");
    if (pickers.length && typeof MutationObserver !== "undefined") {
      var mo = new MutationObserver(onChange);
      pickers.forEach(function (el) {
        mo.observe(el, { subtree: true, attributes: true, attributeFilter: ["checked", "value"] });
      });
    }

    // Initial render — Rise may have auto-selected the first variant.
    buildPills();
    onChange();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

/* Bull Kicks — auto-rotate rescued product-card images (slow, no hover needed).
   Each rescued card carries data-bk-rotate='["url",...]' (720w gallery). We
   cycle the card's base <img> through it on a slow timer, only while the card is
   on screen (IntersectionObserver), staggered so the grid doesn't flip in unison.
   Honors prefers-reduced-motion. Independent of the size-match init above. */
(function () {
  "use strict";
  if (
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  )
    return;
  var INTERVAL = 5000;

  function setup(el, idx) {
    var urls;
    try {
      urls = JSON.parse(el.getAttribute("data-bk-rotate"));
    } catch (e) {
      return;
    }
    if (!Array.isArray(urls) || urls.length < 2) return;
    var img = el.querySelector("img");
    if (!img) return;

    // Preload so swaps don't flicker the first time round.
    urls.forEach(function (u) {
      var pre = new Image();
      pre.src = u;
    });

    var i = 0;
    var startT = null;
    var iv = null;
    function tick() {
      i = (i + 1) % urls.length;
      img.src = urls[i];
      img.srcset = urls[i];
    }
    function start() {
      if (startT || iv) return;
      startT = window.setTimeout(function () {
        startT = null;
        tick();
        iv = window.setInterval(tick, INTERVAL);
      }, (idx % 5) * 500);
    }
    function stop() {
      if (startT) {
        window.clearTimeout(startT);
        startT = null;
      }
      if (iv) {
        window.clearInterval(iv);
        iv = null;
      }
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) start();
          else stop();
        });
      },
      { threshold: 0.25 },
    );
    io.observe(el);
  }

  function initRotate() {
    if (!("IntersectionObserver" in window)) return;
    var els = document.querySelectorAll("[data-bk-rotate]");
    Array.prototype.forEach.call(els, setup);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initRotate);
  } else {
    initRotate();
  }
})();
